import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MonitorInstitutesPage } from '@/features/question/pages/MonitorInstitutesPage';
import { monitorInstitutesSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/monitor/institutes/')({
  validateSearch: monitorInstitutesSearchSchema,
  component: function MonitorInstitutesRoute() {
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Question Monitor Institutes">
        <Suspense fallback={<PageLoader />}>
          <MonitorInstitutesPage search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
